import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SubTitle, Flex, Div } from 'ui';
import { isToggleEnabled } from 'react-awesome-feature-toggles/dist/feature-toggles';
import { mainPartnerTypes, orderStatus } from 'utils/app-configs';
import isEqual from 'lodash.isequal';
import PartnerCard from './partner-card';
import { partnerTypes } from '../../../utils/app-configs';

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  font-size: 12px;
  height: calc(100% - 36px);
`;

const Partners = ({
  partners,
  types,
  canEdit,
  changePartner,
  cardsPerLine = 4,
  activeStatus,
  isPTS,
}) => {
  if (!partners || !partners.length || (!types || !types.length)) {
    return null;
  }

  const canEditPartner = (type, maxEditState) => {
    // TODO: Remove FF check to enable editing on installedAt once SAP supports it
    if (type === partnerTypes.INSTALLEDAT && (!isPTS || !isToggleEnabled('canEditPartner'))) {
      return false;
    }
    if (canEdit && activeStatus && activeStatus.id) {
      return activeStatus.id <= maxEditState;
    }
    return false;
  };

  const data = partners
    ?.map((partner) => {
      const type = types?.find(
        t => t?.type?.toLowerCase() === partner?.partnerFunction?.toLowerCase(),
      );

      const fullType = mainPartnerTypes?.find(p => p.type === type.type);

      const icon = fullType && fullType.icon;

      return {
        key: `${partner.number}_${type.type}`,
        partner,
        type,
        icon,
        sort: fullType ? fullType.sort : 0,
        maxEditState:
          fullType && fullType.maxEditState ? fullType.maxEditState : orderStatus.executed,
      };
    })
    ?.sort((a, b) => a.sort - b.sort);

  return (
    <Div height={'100%'} data-test-id='main-partners'>
      <SubTitle><FormattedMessage id='order.mainPartners.TITLE' /></SubTitle>
      <Wrapper>
        {data?.map((d, i) =>
          <PartnerCard
            icon={d.icon}
            position={i + 1}
            cardsPerLine={cardsPerLine}
            key={d.key}
            partner={d.partner}
            type={d.type}
            changePartner={changePartner}
            canEdit={canEditPartner(d.type.type.toUpperCase(), d.maxEditState)}
          />,
        )}
      </Wrapper>
    </Div>
  );
};

const areEqual = (prevProps, nextProps) => {
  if (
    isEqual(prevProps.partners, nextProps.partners) &&
    isEqual(prevProps.canEdit, nextProps.canEdit) &&
    isEqual(prevProps.types, nextProps.types) &&
    isEqual(
      prevProps.activeStatus && prevProps.activeStatus.id,
      nextProps.activeStatus && nextProps.activeStatus.id,
    )
  ) {
    return true;
  }
  return false;
};


Partners.propTypes = {
  partners: PropTypes.array,
  types: PropTypes.array,
  canEdit: PropTypes.bool,
  changePartner: PropTypes.func,
  cardsPerLine: PropTypes.number,
  activeStatus: PropTypes.object,
  isPTS: PropTypes.bool,
};

export default React.memo(Partners, areEqual);
